import { render, staticRenderFns } from "./AtendimentoImpressaoModal.vue?vue&type=template&id=01893dbc"
import script from "./AtendimentoImpressaoModal.vue?vue&type=script&lang=js"
export * from "./AtendimentoImpressaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports